import type { TagColors } from "ac-components/ac-tag-colored/ACTagColored";

type RuleConfig = { label: string; color: TagColors };

const RULE_MAP: Record<string, RuleConfig> = {
  "arn-match": { label: "ARN", color: "Orange" },
  "hostname-match": { label: "Hostname", color: "Blue" },
  "ip-address-match": { label: "IP Address", color: "Green" },
  "same-source-id-match-rule": { label: "Same Source Id", color: "Indigo" },
  "servicenow-tanium-matching": { label: "ServiceNow Tanium", color: "Purple" },
  "prisma-cloud-compute-id": {
    label: "Prisma Cloud Compute Id",
    color: "Purple",
  },
  "container-image-name-match": {
    label: "Container Image Name",
    color: "Teal",
  },
  "hostname-ipv4-match": { label: "Hostname IPv4", color: "Green" },
  "hostname-ipv6-match": { label: "Hostname IPv6", color: "Green" },
  "partial-hostname-ipv4-match": {
    label: "Partial Hostname IPv4",
    color: "Green",
  },
  "partial-hostname-ipv6-match": {
    label: "Partial Hostname IPv6",
    color: "Green",
  },
  "partial-hostname-match": { label: "Partial Hostname", color: "Blue" },
};

const VALUE_LABELS: Record<string, string> = {
  hostname: "Hostname",
  ipv4: "IPv4",
  ipv6: "IPv6",
  arn: "ARN",
  assetIdFromTool: "Asset ID from Tool",
  type: "Type",
  imageName: "Image Name",
  computerId: "Computer ID",
  computerSerialNo: "Computer Serial No",
};

export const getRuleDisplayLabel = (rule: string): string =>
  RULE_MAP[rule]?.label ?? rule;

export const getRuleColor = (rule: string): TagColors =>
  RULE_MAP[rule]?.color ?? "Neutral";

export const getMatchedValueLabel = (key: string): string =>
  VALUE_LABELS[key] ?? key;
